<template>
  <div class="block" v-if="isPanelOpened" :class="{ 'is-overlay-activated': isOverlayActive, 'is-overlay-created': isOverlayCreate }">
    <div class="block-inner">
      <!-- Categories list -->
      <div class="block-list" v-if="isCategoriesLoaded">
        <category-nav-link v-for="item in categories" v-if="item.product_count > 0" :item="item" :key="item.id" />
      </div>
      <div class="block-list" v-else>
        <nav-panel-preloader v-for="item in pleloaderItems" :key="item" />
      </div>
      <!---->
    </div>
  </div>
</template>

<script>
import NavPanelPreloader from 'theme/components/theme/blocks/Home/Preloaders/NavPanelPreloader'
import CategoryNavLink from 'theme/components/core/blocks/Shop/Navigation/CategoryNavLink'

export default {
  name: 'CategoryNavPanel',
  components: {
    CategoryNavLink,
    NavPanelPreloader
  },
  props: {
    isCategoriesLoaded: {
      type: Boolean,
      default: () => false
    },
    categories: {
      required: true
    }
  },
  data () {
    return {
      pleloaderItems: 14,
      isPanelOpened: false,
      isOverlayActive: false,
      isOverlayCreate: false,
      discountedProductsLink: {
        name: 'Товари зі знижкою',
        url_path: 'discounted-products',
        url_key: 'discounted-products',
        slug: 'discounted-products',
        children_count: 0,
        children_data: [],
        product_count: 0
      }
    }
  },
  created () {
    this.$bus.$on('toggle-category-panel', () => { this.isPanelOpened = !this.isPanelOpened })
    this.$bus.$on('show-overlay-in-shop', () => {
      this.isOverlayCreate = true
      setTimeout(() => { this.isOverlayActive = true }, 100)
    })
    this.$bus.$on('hide-overlay-in-shop', () => {
      this.isOverlayActive = false
      setTimeout(() => { this.isOverlayCreate = false }, 100)
    })
  },
  mounted () {
    if (this.getSlugParam && !this.getSkuParam) {
      this.isPanelOpened = false
    }
    else if ((this.getSlugParam && this.getSkuParam) || (!this.getSlugParam && !this.getSkuParam)) {
      this.isPanelOpened = true
    }
  },
  watch: {
    '$route.params.slug': {
      handler: function () {
        if (this.getSlugParam && !this.getSkuParam) {
          this.isPanelOpened = false
        }
        else if ((this.getSlugParam && this.getSkuParam) || (!this.getSlugParam && !this.getSkuParam)) {
          this.isPanelOpened = true
        }
      }
    },
    isPanelOpened: {
      handler() {
        this.$emit('changesIcon', this.isPanelOpened)
      }
    }
  },
  computed: {
    getSlugParam () {
      return this.$route.params.slug
    },
    getSkuParam () {
      return this.$route.params.childSku
    }
  }
}
</script>

<style lang="scss" scoped>
.block {
  width: 262px;
  margin: auto;

  position: absolute;
  top: 65px;

  background: #f5f5f5;
  border-radius: 5px;
  //box-shadow: 1px 2px 7px 0 rgba(0, 0, 0, .20);
  z-index: 5;

  &:before {
    width: 262px;
    margin: auto;

    display: none;
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    content: '';

    border-radius: 5px;
    background: transparent;
    z-index: 2;

    transition: .2s;
  }

  &.is-overlay-activated:before {
    background: rgba(0, 0, 0, .4);
  }

  &.is-overlay-created:before {
    display: block;
  }


  @media only screen and (max-width: 991px) {
    display: none;
  }

  &-inner {
    padding: 10px 0;
  }

  &-list {
    display: flex;
    flex-direction: column;

    overflow-y: scroll;

    &::-webkit-scrollbar {
      width: 0;
    }

    &::-webkit-scrollbar-track {
      border-radius: 10px;
      background: #fff;
    }

    &::-webkit-scrollbar-thumb {
      width: 0;
      border-radius: 10px;
      background: #f5a623;
    }
  }
}
</style>
